import styled from 'styled-components';
import { Heading as HeadingComponent, mediaQueries } from '@fourthwall/components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-400);
`;
export const Items = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-400);

  ${mediaQueries.tablet} {
    flex-direction: row;
  }
`;
export const Item = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--space-400) 0 var(--space-500) 0;
  gap: var(--space-400);
  cursor: pointer;

  border-radius: var(--radius-brand);
  border: 1px solid var(--border-secondary);

  ${mediaQueries.tablet} {
    flex-direction: column;
    justify-content: center;
    flex: 1;
    position: relative;

    &:hover {
      background-color: var(--bg-secondary);
    }
  }
`;
export const ItemImageContainer = styled.div `
  min-width: 120px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  aspect-ratio: 120 / 84;

  ${mediaQueries.tablet} {
    width: 100%;
  }
`;
export const Image = styled.img `
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
export const Content = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-100);

  ${mediaQueries.tablet} {
    gap: var(--space-200);
    align-items: center;
  }
`;
export const Heading = styled(HeadingComponent) `
  font-size: var(--font-size-500);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-500);
`;
export const Subheading = styled.p `
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-400);
  color: var(--text-secondary);
  text-align: left;

  ${mediaQueries.tablet} {
    font-size: var(--font-size-400);
    text-align: center;
  }
`;
export const SkeletonItem = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--space-400) 0 var(--space-500) 0;
  gap: var(--space-400);

  border-radius: var(--radius-brand);
  background-color: var(--bg-secondary);

  ${mediaQueries.tablet} {
    flex-direction: column;
    justify-content: center;
    flex: 1;
    position: relative;
  }
`;
